export default __webpack_public_path__ + "static/media/none_show.d127fcb2.png";